<main>
    <div class="d-flex flex-row justify-content-center">
        <h1 class="my-10 f-18">
            Memory Boxes
        </h1>
    </div>
    <div class="mediumContainer">
        <mat-form-field appearance="outline" class="w-100 noBottomPadding" color="primary">
            <mat-label>Search</mat-label>
            <input (keyup)="keyup()"
                   (keyup.enter)="getTimelines()"
                   [(ngModel)]="searchTerm"
                   matInput type="text"/>
            <button (click)="getTimelines()" (keyup.enter)="getTimelines()" [disabled]="!searchTerm"
                    aria-label="Search"
                    mat-icon-button matPrefix matTooltip="Search Memories">
                <mat-icon color="primary">
                    search
                </mat-icon>
            </button>
            @if (searchTerm) {
                <button (click)="clearSearch()" (keyup.enter)="clearSearch()" aria-label="Clear Search"
                        mat-icon-button matSuffix>
                    <mat-icon>close</mat-icon>
                </button>
            }
        </mat-form-field>

        @if (loading) {
            <mat-progress-bar aria-label="Loading memory boxes" class="mt-10" color="primary"
                              mode="indeterminate"></mat-progress-bar>
        }
        @if ((!timelines || timelines.length <= 0) && !loading) {
            <div aria-live="polite" class="text-center" role="status">
                @if (this.searchTerm) {
                    <p>
                        We're sorry, no Memory Boxes were found for your search: "{{ searchTerm }}".
                    </p>
                } @else {
                    <p>
                        Your admin has not set your permissions to view a memory box yet.<br> Please contact your admin
                        to request access to your Children and Young People on
                        @if (contactEmail) {
                            <a [href]="'mailto:' +contactEmail">{{ contactEmail }}</a>
                        }.
                    </p>
                }
            </div>
        }
        @if (user) {
            <div class="peopleContainer">
                @for (timeline of timelines; track timeline) {
                    <div class="card">
                        <mat-card [attr.aria-label]="'View ' +  (timeline| nameDisplay)  + '\'s Memory Box'"
                                  [routerLink]=" ['/timeline', timeline.id]"
                                  class="clickable">
                            <img [src]="timeline.photo || 'assets/images/blankProfile.png'"
                                 alt="{{timeline| nameDisplay}}'s Photo"
                                 class="squareImage" loading="lazy" decoding="async"
                                 width="300" height="300" mat-card-image>
                            <mat-card-header>
                                @if (timeline.owner?.id === user.id) {
                                    <mat-card-title>My Profile</mat-card-title>
                                } @else {
                                    <mat-card-title>{{ timeline| nameDisplay }}
                                    </mat-card-title>
                                }
                            </mat-card-header>
                            <mat-card-content>
                                <small>{{ timeline.owner?.role?.name }}</small>
                            </mat-card-content>
                            <mat-card-actions class="flex-col gap10 flex-space-between">
                                <button [attr.aria-label]="'View ' +  (timeline| nameDisplay)  + '\'s Memory Box'"
                                        [routerLink]="['/timeline', timeline.id]"
                                        color="primary"
                                        mat-raised-button>View Memory Box
                                </button>
                                @if (showProfileButton(timeline)) {
                                    <button
                                            [attr.aria-label]="profileButtonLabel + ' for ' + (timeline| nameDisplay)"
                                            [routerLink]="['/profile',0, timeline.id]"
                                            color="primary"
                                            mat-raised-button>{{ profileButtonLabel }}
                                    </button>
                                }
                            </mat-card-actions>
                        </mat-card>
                    </div>
                }
                @if (boxCount > timelines.length) {
                    <div class="w-100 text-center">
                        <button (click)="this.getMoreTimelines()" (keyup.enter)="getMoreTimelines()"
                                [disabled]="loading"
                                color="primary"
                                mat-raised-button>Load More
                            @if (loading) {
                                <mat-spinner [diameter]="24" aria-label="Loading more memory boxes"
                                             class="ms-2"></mat-spinner>
                            }
                        </button>
                    </div>
                }
            </div>
        }
    </div>
</main>
